var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-479.5 -464.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.5 477.615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.374,511.385H480.626a1.138,1.138,0,0,1-1.126-1.148v-1.311a.492.492,0,0,1,.256-.432l7.213-3.935a.492.492,0,0,1,.471.864l-6.957,3.8v1.019a.156.156,0,0,0,.142.164h17.748a.156.156,0,0,0,.142-.164v-1.02l-6.947-3.794a.492.492,0,0,1,.471-.863l7.2,3.934a.491.491,0,0,1,.256.431v1.312A1.138,1.138,0,0,1,498.374,511.385Z",
    transform: "translate(-479.5 -504.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484.09 464.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.215,478.6a.492.492,0,0,1-.252-.914c2.338-1.4,2.373-5.167,2.373-5.205l0-3.7c-.348-1.932-2.575-3.279-4.39-3.3h-.034c-1.822,0-4.074,1.351-4.422,3.295l0,3.7c0,.036.036,3.706,2.4,5.21a.492.492,0,1,1-.529.829c-2.818-1.8-2.85-5.868-2.85-6.04l0-3.744a.5.5,0,0,1,.007-.08c.41-2.472,3.1-4.137,5.362-4.155h.038c2.274,0,4.987,1.67,5.4,4.156a.51.51,0,0,1,.007.081l0,3.743c0,.178-.032,4.366-2.852,6.049A.488.488,0,0,1,501.215,478.6Z",
    transform: "translate(-493.5 -464.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.0bcc5aaa87d865cae72eb57289b51691.svg";
export { ForwardRef as ReactComponent };